import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { setLoading } from "../../store/slices/auth";
import { copyData } from "../../utils/Utils";
import { CustomButton, showToaster, toasterTypes } from "../../widgets";
import { FieldItem, FIELD_TYPES } from "../../widgets/fields";
import useFieldItem from "../../widgets/fields/UseFieldItem";
import ModalPopup from "../../widgets/modal";
import CustomTable from "../../widgets/table";
import Tabs from "../sampleSize/Tabs";
import PlanDataCardMobile from "./PlanDataCardMobile";

import {
  deletePlan,
  getPermissionData,
  getPlanData,
  getPlans,
  updateProjectStatus
} from "./apiController";
import CreateForm from "./CreatePlan";
import {
  ArrowLeftOutlined,
  BackwardOutlined,
  CopyOutlined,
  LockOutlined,
  UnlockOutlined,
} from "@ant-design/icons";
import ModalComponent from "../common/Modal/modal";
import ViewGanttChart from "./ViewGanttChart";
import { TabsData } from "../../utils/TabsData";
import TopBar from "../../layouts/postLogin/TopBar";

export default function Planner(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [projectData, setprojectData] = useState<any | null>(null);
  const [userData, setuserData] = useState<any | null>(null);
  const [selectedForm, setselectedForm] = useState<any | null>(null);
  const [forms, setforms] = useState<any | null>([]);
  const [plans, setplans] = useState<any | null>([]);
  const [planData, setplanData] = useState<any | null>(null);
  const [temporaryTasksData, setTemporaryTasksData] = useState<any | null>([]);
  const [temporaryPlanData, setTemporaryPlanData] = useState<any | null>(null);
  const [action, setaction] = useState<any | "">("");
  const [lockData, SetLockData] = useState<any>({});
  const [formData, setformData] = useState<any | null>(null);
  const [formCount, SetFormCount] = useState(0);
  const [permissionParams, setPermissionParams] = useState<any>({});
  const [formTemplates, setFormTemplates] = useState<any>([]);
  const [isRearranged, setIsRearranged] = useState(false);
  const [isPlanDelayedPopup, setIsPlanDelayedPopup] = useState<boolean>(false);
  const [delayedReason, setDelayedReason] = useState<any | null>(null);

  /**
   * tabs items
   */
  const tabData = [
    {
      title: "Project Details",
      id: 1,
      tab: "project details",
    },
    {
      title: "Study Design",
      id: 2,
      tab: "study design",
    },
    {
      title: "Data Collection",
      id: 3,
      tab: "Data collection",
    },
    {
      title: "Data Analysis",
      id: 4,
      tab: "Data analysis",
    },
    {
      title: "People",
      id: 5,
      tab: "people",
    },
    {
      title: "Planner",
      id: 6,
      tab: "planner",
    },
    {
      title: "Registered Events",
      id: 7,
      tab: "register events",
    },
    // {
    //   title: "Mentors",
    //   id: 8,
    //   tab: "mentors",
    // },
  ];

  /**
   * form elements
   */
  const FormElements = {
    lockmode: {
      name: "lockmode",
      placeholder: "Please enter remarks",
      label: "Remarks to Unlock",
      type: FIELD_TYPES.TEXT_AREA,
      isMandatory: true,
    },
    formTemplate: {
      name: "formTemplate",
      placeholder: "Select",
      label: "Select Template",
      type: FIELD_TYPES.DROP_DOWN,
      isMandatory: false,
    },
    formName: {
      name: "formName",
      placeholder: "Form Name",
      label: "New Form Name",
      type: FIELD_TYPES.TEXT,
      isMandatory: true,
    },
    formTypes: {
      name: "formType",
      placeholder: "Form Type",
      label: "",
      type: FIELD_TYPES.RADIO_BUTTON,
      values: [
        { label: "Create custom planner", value: "createform" },
        { label: "Create planner using template", value: "createtemplate" },
      ],
      isMandatory: true,
    },
    reasonForDelay: {
      name: "reasonForDelay",
      placeholder: "Reason for delay",
      label: "Reason for delay",
      type: FIELD_TYPES.DROP_DOWN,
      values: [
        { value: "Reduced Patient Flow", label: "Reduced Patient Flow" },
        { value: "Defunct Equipment", label: "Defunct Equipment" },
        { value: "Lack Of Time", label: "Lack Of Time" },
        { value: "Delay In Arrival Of Equipment", label: "Delay In Arrival Of Equipment" },
        { value: "Researcher Attrition", label: "Researcher Attrition" },
        { value: "Others", label: "Others" }
      ],
      isMandatory: true,
    }
  };

  const [values, fields, handleChange, { validateValues, updateValue }] =
    useFieldItem(FormElements, {}, { onValueChange });

  /**
   * handle on change values of form elements
   * @param name
   * @param value
   * @param values
   * @param fieldValues
   * @returns
   */
  function onValueChange(name, value, values, fieldValues = null) {
    const resetValue = {};
    if (name == "formType") {
      setaction(value);
    }
    return [
      {
        ...values,
        ...resetValue,
        [name]: value,
      },
    ];
  }

  /**
   * table header
   */
  const columns = [
    {
      id: "plan_name",
      label: "Plan Name",
      accessor: "plan_name",
      sort: "asc",
    },
    {
      id: "total_tasks",
      label: "Total Tasks",
      className: "text-center",
      width: '50',
      Cell: ({ row, data }) => {
        const { original } = row;
        return <>
          <span>{original.total_tasks ? original.total_tasks : "0"}</span>
        </>
      },
    },
    {
      id: "status",
      label: "Status",
      className: "text-center",
      Cell: ({ row, data }) => {
        const { original } = row;
        return <>
          <span>In Progress</span>
        </>
      },
    },
    {
      id: "start_date",
      label: "Start date",
      className: "text-center",
      Cell: ({ row, data }) => {
        const { original } = row;
        const isoDate = original.plan_start_date;
        const date = new Date(isoDate);
        const dateString = date.toLocaleDateString();
        return <>
          <span>{dateString}</span>
        </>;
      },
    },
    {
      id: "end_date",
      label: "End date",
      className: "text-center",
      Cell: ({ row, data }) => {
        const { original } = row;
        const isoDate = original.plan_end_date;
        const date = new Date(isoDate);
        const dateString = date.toLocaleDateString();
        return <>
          <span>{dateString}</span>
        </>;
      },
    },
    {
      id: "progress",
      label: "Progress",
      width: "20",
      className: "text-center",
      Cell: ({ row, data }) => {
        const { original } = row;
        return (
          permissionParams.progress_view == "allowed" || Object.keys(permissionParams).length == 0 ?
            <i
              className="icon icon-eye"
              onClick={() => onAction(5, original)}
            ></i>
            : "-"
        );
      },
    },
    {
      id: "view",
      label: "View",
      width: "20",
      className: "text-center",
      Cell: ({ row, data }) => {
        const { original } = row;
        return (
          permissionParams.view == "allowed" || Object.keys(permissionParams).length == 0 ?
            <i
              className="icon icon-eye"
              onClick={() => onAction(1, original)}
            ></i>
            : "-"
        );
      },
    },
    {
      id: "edit",
      label: "Edit",
      width: "20",
      className: "text-center",
      Cell: ({ row, data }) => {
        const { original } = row;
        return (
          permissionParams.edit == "allowed" || Object.keys(permissionParams).length == 0 ?
            <i
              className="icon icon-edit"
              onClick={() => onAction(2, original)}
            ></i>
            : "-"
        );
      },
    },
    {
      id: "delete",
      label: "Delete",
      width: "30",
      className: "text-center",
      Cell: ({ row, data }) => {
        const { original } = row;
        return (
          permissionParams.delete == "allowed" || Object.keys(permissionParams).length == 0 ?
            <i
              className="icon icon-delete"
              onClick={() => onAction(3, original)}
            ></i>
            : "-"
        );
      },
    }
  ];

  useEffect(() => {
    if (location.state) {
      let tempState: any = location.state;
      setprojectData(tempState);
      let temp: any = localStorage.getItem("coguide_user");
      if (temp) {
        temp = JSON.parse(temp);
        setuserData(temp);
        fetchPlans(tempState.id);
      }
      getPermissions(temp, tempState);
    } else {
      navigate("/project");
    }
  }, [location.state, navigate]);

  const fetchPlans = async (id = "") => {
    try {
      dispatch(setLoading(true));
      let tempPlans = await getPlans(id || projectData.id);
      console.log(tempPlans)
      setplans(tempPlans || []);
      checkForDelay(tempPlans || []);
      dispatch(setLoading(false));
    } catch (e: any) {
      dispatch(setLoading(false));
    }
  }

  function getDelayStatus(data) {
    const onTime = "Ontime";
    const delayed = "Delayed";
    const significantlyDelayed = "Significantly delayed";

    const { status, planned_start_date, planned_end_date, actual_start_date, actual_end_date } = data;
    const plannedStart = new Date(planned_start_date);
    const plannedEnd = new Date(planned_end_date);
    const actualStart = new Date(actual_start_date);
    const actualEnd = new Date(actual_end_date);

    const today = new Date();

    // Calculate the total duration between the planned start and end dates
    const totalDuration = plannedEnd.getTime() - plannedStart.getTime();

    // Calculate 20% of the total duration
    const delayThreshold = totalDuration * 0.2;

    // Calculate the date for 20% of the total duration from the planned start date
    const delayFromStartDate = new Date(plannedStart.getTime() + delayThreshold);
    // Calculate the date for 20% of the total duration from the planned end date
    const delayFromEndDate = new Date(plannedEnd.getTime() + delayThreshold);

    if (!status || status === "Not Started") {
      if (today <= plannedStart) {
        return onTime;
      }
      else if (today > plannedStart && today <= delayFromStartDate) {
        return delayed;
      }
      else {
        return significantlyDelayed;
      }
    } else if (status && status === "In Progress") {
      if (actualStart <= plannedStart) {
        return onTime;
      }
      else if (actualStart > plannedStart && actualStart <= delayFromStartDate) {
        return delayed;
      }
      else if (actualStart > plannedStart && actualStart > delayFromStartDate) {
        return significantlyDelayed;
      }
      return onTime;
    } else if (status && status === "Completed") {
      if (actualEnd <= plannedEnd) {
        return onTime;
      } else if (actualEnd > plannedEnd && actualEnd <= delayFromEndDate) {
        return delayed;
      } else if (actualEnd > plannedEnd && actualEnd > delayFromEndDate) {
        return significantlyDelayed;
      }
      return onTime;
    }
    return onTime;

  }

  /**
   * check for delay
   * @param plans 
   */

  const checkForDelay = async (plans) => {
    console.log(plans)
    if(!plans || plans.length === 0){
      return ;
    }
    const firstPlan = plans[0];
    const response = await getPlanData(firstPlan?.id);
    const tasks = response?.data?.tasks || [];
  
    const isDelayed = tasks.some((task) => {
      const status = getDelayStatus(task);
      return status === "Delayed" || status === "Significantly delayed";
    });
    
    if(isDelayed){
      setIsPlanDelayedPopup(isDelayed);
    }
    else{
      try {
        dispatch(setLoading(true));
        const reqObj = {
          "topic_id": projectData.TopicID,
          "project_status":"Ontime",
          "project_delay_reason": ""
        }
        let response = await updateProjectStatus(reqObj);
        dispatch(setLoading(false));
        setaction("");
        setIsPlanDelayedPopup(false);
      } catch (e: any) {
        dispatch(setLoading(false));
      }
    }
  };

  /**
   * check task delay
   * @returns 
   */

  async function checkPlanStatus() {
    const firstPlan = plans[0];
    const response = await getPlanData(firstPlan?.id);
    const tasks = response?.data?.tasks || [];
  
    let hasDelayed = false;
  
    for (const task of tasks) {
      const status = getDelayStatus(task);
      if (status === "Significantly delayed") {
        return "Significantly delayed";
      } else if (status === "Delayed") {
        hasDelayed = true;
      }
    }
  
    return hasDelayed ? "Delayed" : "Ontime";
  }

  /**
   * send reason for delay
   */
  const sendReasonForDelay = async () => {
    try {
      dispatch(setLoading(true));
      const projectStatus = checkPlanStatus();
      if(!delayedReason){
        return;
      }
      const reqObj = {
        "topic_id": projectData.TopicID,
        "project_status":projectStatus,
        "project_delay_reason": delayedReason.value
      }
      let response = await updateProjectStatus(reqObj);
      dispatch(setLoading(false));
      setaction("");
      setIsPlanDelayedPopup(false);
    } catch (e: any) {
      dispatch(setLoading(false));
    }
  }

  /**
   * argument permissions data
   * @param data 
   */
  const getPermissions = async (userdata, projectdata) => {
    const userId = userdata?.id;
    const projectId = projectdata?.id;
    const type = userData?.UserType;
    const permissionData = await getPermissionData("mentor", userId, projectId);
    const plannerPermissions = permissionData.data.find(item => 'Planner' in item);
    if (plannerPermissions && plannerPermissions?.Planner) {
      const newPermissions = {};
      plannerPermissions?.Planner?.forEach((item) => {
        const selectedPermission = item.permissions.find(permission => permission.is_selected);
        newPermissions[item.action] = selectedPermission.permission;
      });
      // setPermissionParams(newPermissions);
    }

  }


  /**
   * actions for button clicks
   * @param type
   * @param data
   */
  const onAction = async (type, data: any = null) => {
    switch (type) {
      case 1:
        try {
          dispatch(setLoading(true));
          let response = await getPlanData(data?.id);
          setplanData(response?.data);
          dispatch(setLoading(false));
          setaction(type);
        } catch (e: any) {
          dispatch(setLoading(false));
        }
        break;
      case 2:
        try {
          dispatch(setLoading(true));
          let response = await getPlanData(data?.id);
          setplanData(response?.data);
          dispatch(setLoading(false));
          setaction(type);
        } catch (e: any) {
          dispatch(setLoading(false));
        }
        break;
      case 3:
        setplanData(data);
        setaction(type);
        break;
      case 5:
        try {
          dispatch(setLoading(true));
          let response = await getPlanData(data?.id);
          setplanData(response?.data);
          dispatch(setLoading(false));
          setaction(type);
        } catch (e: any) {
          dispatch(setLoading(false));
        }
        break;
      default:
        setaction(type);
        break;
    }
  };

  /**
   * on From crete get all the forms list
   */
  const onFormCreation = () => {
    setaction("");
    setplans([]);
    fetchPlans(projectData.id);
  };

  //delete action
  const onDelete = async () => {
    try {
      dispatch(setLoading(true));
      let response = await deletePlan(planData?.id);
      setaction("");
      fetchPlans();
      showToaster(toasterTypes.SUCCESS, response.message);
    } catch (e: any) {
      dispatch(setLoading(false));
    }
  };

  //onclose
  const onCloseView = (type = "") => {
    if (type === "forms") {
      onFormCreation();
    }
    setaction("");
  };


  return (
    <div className="planner">
      {(action == 5) && (
        <ViewGanttChart
          {...props}
          formData={planData}
          userData={userData}
          projectData={projectData}
          permissionParams={permissionParams}
          onClose={() => setaction("")}
        />
      )
      }
      {(action == "createform" || action === 2) && (
        <CreateForm
          {...props}
          formData={planData}
          isEdit={action === 2}
          projectData={projectData}
          temporaryPlanData={temporaryPlanData}
          setTemporaryPlanData={setTemporaryPlanData}
          temporaryTasksData={temporaryTasksData}
          setTemporaryTasksData={setTemporaryTasksData}
          onClose={() => setaction("")}
          onFormCreation={() => onFormCreation()}
        />
      )}
      {(action == "createtemplate") && (
        <CreateForm
          {...props}
          formData={planData}
          isEdit={false}
          isTemplate={true}
          projectData={projectData}
          onClose={() => setaction("")}
          onFormCreation={() => onFormCreation()}
        />
      )}
      {(action === 1) && (
        <CreateForm
          {...props}
          formData={planData}
          isEdit={action === 1}
          isView={action === 1}
          projectData={projectData}
          onClose={() => setaction("")}
          onFormCreation={() => onFormCreation()}
        />
      )}
      {action === 4 && (
        <ModalComponent
          width={"350px"}
          isOpen={true}
          onClose={() => setaction("")}
          header={"Create Plan"}
          centered={true}
          customClass="plan-template-modal"
          body={
            <>
              <div className="plan-template">
                <FieldItem
                  {...FormElements.formTypes}
                  value={values.formType}
                  onChange={(...e) =>
                    handleChange(FormElements.formTypes.name, ...e)
                  }
                  touched={fields.formTypes && fields.formTypes.hasError}
                  error={fields.formTypes && fields.formTypes.errorMsg}
                />
              </div>
            </>
          }
          footer={<></>}
        />
      )}
      {action === 3 && (
        <ModalPopup
          modalType="delete"
          modalText="Are you sure, you want to delete?"
          actionText="This action cannot be undone"
          closeModal={() => {
            setaction("");
            setplanData(null);
          }}
          onAction={() => onDelete()}
        />
      )}
      {action !== 5 &&
        <>
          {/* <Row className='page-header m-0'>
            <Col className={window.innerWidth > 750 ? "project-title" : "project-title-mob"} md={12}>
              <ArrowLeftOutlined style={{ color: "#fff", fontSize: "24px", margin: "0px 10px" }} onClick={() => window.innerWidth > 750 ? navigate("/project") : navigate("/projectmobile")} />
              {projectData?.TopicDesc || projectData?.topicdesc}
            </Col>
            <Col className='p-0'></Col>
          </Row> */}
          <TopBar projectData={projectData} navigate={window.innerWidth > 750 ? "/project" : "/projectmobile"} />

          <Tabs data={TabsData} selectedTab={7} projectData={projectData} />
          {isPlanDelayedPopup &&
            <ModalComponent
              width={"350px"}
              isOpen={true}
              onClose={() => setIsPlanDelayedPopup(false)}
              header={"Please Select Reason for delay of Project"}
              centered={true}
              customClass="plan-template-modal"
              body={
                <>
                  <Col md={12}>
                    <FieldItem
                      {...FormElements.reasonForDelay}
                      value={delayedReason}
                      onChange={(...e) =>
                        setDelayedReason(...e)
                      }
                      touched={fields.formTypes && fields.formTypes.hasError}
                      error={fields.formTypes && fields.formTypes.errorMsg}
                    />
                  </Col>
                </>
              }
              footer={<>
                <CustomButton
                  className="mt-2"
                  type="alert-primary"
                  text="Submit"
                  onClick={() => sendReasonForDelay()}
                ></CustomButton>
              </>}
            />
          }
          {window.innerWidth > 750 ?
            <Row className="m-0 planner-page-height">
              <Col
                className="p-0 col-md-9"
                style={{
                  minWidth: "100%",
                }}
              >
                <div className="p-3 d-flex justify-content-between ">
                  <span className="font-weight-bold">Planner</span>
                </div>
                <div className="p-3">
                  {plans.length > 0 ? (
                    <CustomTable
                      header="Plans"
                      data={plans}
                      tableProps={columns}
                      isSearch={false}
                      isFilter={false}
                      isSelect={false}
                      isSort={false}
                      isView={false}
                      isDraggable={false}
                      isRearranged={isRearranged}
                      isCreate={permissionParams.createPlan == "allowed" || Object.keys(permissionParams).length == 0 ? true : false}
                      onAction={(type, data = null) => onAction(type, data)}
                    ></CustomTable>
                  ) : (
                    <div className="group-center">
                      <div>
                        No Plans
                      </div>
                      {plans.length === 0 && (
                        <Row>
                          {
                            permissionParams.create == "allowed" || Object.keys(permissionParams).length == 0 ?
                              <CustomButton
                                className="mt-2"
                                type="primary"
                                text="Create Plan"
                                onClick={() => onAction(4)}
                              ></CustomButton> : ""
                          }
                        </Row>
                      )}
                    </div>
                  )}
                </div>
              </Col>
            </Row>
            :
            <div className="planner-data-mobile">

              <div className="plan-list">
                <div className="plans">
                  <span>Plans | {plans && plans.length}</span>
                </div>
                {
                  plans && plans.map((items, i) => {
                    return <><PlanDataCardMobile
                      data={items}
                      permissionParams={permissionParams}
                      onActions={onAction}
                      projectData={projectData}
                    />
                      <hr></hr>
                    </>
                  })
                }
              </div>
              <div className="footer-button">
                {
                  permissionParams.create == "allowed" || Object.keys(permissionParams).length == 0 ?
                    <CustomButton type="primary" text="create" onClick={() => onAction(4)}></CustomButton>
                    : ""
                }
              </div>
            </div>
          }

        </>
      }
    </div>
  );
}